// Cmd+K (Mac) / Ctrl+K (Windows, Linux) focuses the list's search box.
// The search <el-input> needs ref="searchShortcutInput", or the component can
// name another ref through the `searchShortcutRef` option.
import { setShortcutAvailable } from "@/mixins/keyboardShortcutGuards";

export default {
  computed: {
    // One entry per keycap shown in the search box.
    searchShortcutKeys() {
      const platform =
        (typeof navigator !== "undefined" &&
          (navigator.userAgentData?.platform || navigator.platform)) ||
        "";
      return /mac|iphone|ipad/i.test(platform) ? ["⌘", "K"] : ["Ctrl", "K"];
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onSearchShortcutKeydown);
    setShortcutAvailable("search", true);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onSearchShortcutKeydown);
    setShortcutAvailable("search", false);
  },
  methods: {
    onSearchShortcutKeydown(event) {
      if (!(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey) {
        return;
      }
      if (String(event.key).toLowerCase() !== "k") {
        return;
      }
      const input =
        this.$refs[this.$options.searchShortcutRef || "searchShortcutInput"];
      if (!input || typeof input.focus !== "function") {
        return;
      }
      // Stops the browser's own Ctrl+K (address bar search in some browsers).
      event.preventDefault();
      input.focus();
      if (typeof input.select === "function") {
        input.select();
      }
    },
  },
};
